import React, { useMemo, useEffect } from 'react';
import styled from '@emotion/styled';
import { useMount, useHover } from 'react-use';
import { useAccordionContext } from './Accordion';
import { ID } from '@/src/hooks/types';
import { BinIcon } from '../icon/BinIcon';

export interface AccordionPanelProps extends AccordionPanelState {
  id: ID,
  title: string;
  actionRender?: () => React.ReactElement;
  children?: React.ReactChild;
}

export interface AccordionPanelState {

}
export function useAccordionPanel(): AccordionPanelState {
  return {} as AccordionPanelState;
}

export function AccordionPanel(props: AccordionPanelProps) {
  const {
    id,
    title,
    actionRender,
    children,
  } = props;
  const {
    Container,
    Panel,
    Title,
    Header,
    Action,
  } = S;
  const { activeID, panelHeight, setActiveID } = useAccordionContext();

  const [el, hoverd] = useHover((hoved) => (
    <Container>
      <Header
        onClick={() => {
          if (activeID === id) {
            setActiveID(undefined);
          } else {
            setActiveID(id);
          }
        }}
      >
        <BinIcon size={8} type={activeID === id ? "right" : "down"} />
        <Title>
          {title}
        </Title>
        <Action
          onClick={e => e.stopPropagation()}
        >
          {(actionRender && hoved && id === activeID) ? actionRender() : null}
        </Action>
      </Header>

      <Panel
        isShow={id === activeID}
        height={panelHeight}
      >
        {children}
      </Panel>
    </Container>
  ))

  return el;
}
const S = {
  Container: styled.div``,
  Title: styled.div`
    display: inline-block;
    padding-left: 4px;
  `,
  Header: styled.div`
    user-select: none;
    cursor: pointer;
    font-size: 12px;
    color: #fff;
    font-weight: 600;
    background-color: #000;
    padding: 2px 4px;
  `,
  Action: styled.div`
    float: right;
  `,
  Panel: styled.div<{ isShow: boolean, height: number }>`
    overflow: auto;
    height: ${props => props.isShow ? props.height : 0}px;
    transition: height 0.1s;
  `,
}
